import React from 'react';
import pt from 'prop-types';
import { FieldLocalized } from 'components/form';
import withWidget from './with-widget';
import withLocale from './with-locale';

function SwellEditor({ value, localeValue, field, localized, onChange }) {
  const { prop, label, description, defaultValue, params } = field;
  let { type } = params || {};

  // Map types to appropriate toolbar and functionality
  const hasBaseFunctionality = type === 'rich_text' || type === 'rich_html';
  const toolbar = type === 'rich_html' ? 'rich_html' : 'rich_text';

  return (
    <FieldLocalized
      type="editor"
      name={prop}
      label={label}
      value={value}
      defaultValue={defaultValue}
      localeValue={localeValue}
      onChange={onChange}
      toolbar={toolbar}
      baseTagsOnly={hasBaseFunctionality}
      hint={description}
      localized={localized}
      tooltipAlign="end"
      hintOnLast
    />
  );
}

SwellEditor.propTypes = {
  value: pt.string,
  localeValue: pt.string,
  field: pt.object,
  localized: pt.bool,
  onChange: pt.func,
};

export default withWidget(withLocale(SwellEditor));
